'use client'

import { useTranslation } from '@shared/config/i18n'
import { useMemo } from 'react'

import { ChipWithBadge, HStack } from '@podo-app/design-system-temp'

import type { PeriodItem } from '../../api/subscribe-v2.api'

const LOWEST_PRICE_BADGE_PATTERN = /^최저가$/
const POPULAR_BADGE_PATTERN = /^인기$/

const getBadgeColor = (badge: string | null): 'red' | 'blue' | undefined => {
  if (badge && LOWEST_PRICE_BADGE_PATTERN.test(badge)) {
    return 'red'
  }
  if (badge && POPULAR_BADGE_PATTERN.test(badge)) {
    return 'blue'
  }
  return undefined
}

type Props = {
  selectedPeriod: number
  handleChangePeriod: (period: number) => void
  periodList: PeriodItem[]
  selectedProduct?: string
}

const SubscribeTicketPeriodChip = ({ selectedPeriod, handleChangePeriod, periodList, selectedProduct }: Props) => {
  const t = useTranslation()
  const filteredPeriodList = useMemo(() => {
    if (selectedProduct === 'IPAD') {
      return periodList.filter((item) => item.period === 12 || item.period === 6)
    }
    return periodList
  }, [periodList, selectedProduct])

  const getBadgeText = (badge: string | null) => {
    if (badge && LOWEST_PRICE_BADGE_PATTERN.test(badge)) {
      return t('subscribeList.chip.lowestPrice')
    }
    if (badge && POPULAR_BADGE_PATTERN.test(badge)) {
      return t('subscribeList.chip.popular')
    }
    return badge ?? undefined
  }

  return (
    <HStack className="gap-2">
      {filteredPeriodList.map((item) => (
        <ChipWithBadge
          key={item.period}
          selected={selectedPeriod === item.period}
          onClick={() => handleChangePeriod(item.period)}
          fontWeight="semibold"
          badgeText={getBadgeText(item.badge)}
          badgeColor={getBadgeColor(item.badge)}
          data-testid={`chip-period-${item.period}`}
        >
          {t('subscribeList.ticket.months', { count: item.period })}
        </ChipWithBadge>
      ))}
    </HStack>
  )
}

export default SubscribeTicketPeriodChip
